import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {update} from "../../../app/setters/update.js";

export const usePrzepnijProjekt = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data) => update(`/oper/rejestr/przepnij-projekt`, {id: data.projectId, nowy_profil_id: data.newProfileId}),
        onSettled: async () => {
            await queryClient.invalidateQueries({
                predicate: query => query.queryKey[0]?.startsWith?.('lista_projektow__'),
            });
        },
        onSuccess: ({message}) => {
            toast.success(message)
        },
        onError: (error) => {
            toast.error(error?.message || 'Wystąpił błąd')
        }
    });
};
